import React from "react";
import styled from "styled-components";
import { colors } from "../../../../theme";
import codeIcon from "../../../images/code-icon.svg";
import calenderIcon from "../../../images/calender-icon.svg";
import locationIcon from "../../../images/location-icon.svg";
import verifiedIcon from "../../../images/verified-check.svg";
import Expertise from "./expertise";
import VettedBy from "../vetted-by";

//styles
const IntroSection = styled.section`
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #d1d5db;
`;

const Name = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: ${colors.accentContent};
  margin-bottom: 0.25rem;
`;

const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const VerifiedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: #057663;
  img {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
  }
`;

const MetaList = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-bottom: 40px;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #455065;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
  }
`;

const Bio = styled.p`
  font-size: 1rem;
  color: #374151;
  line-height: 1.6;
  margin-top: 0;
`;

const BioHeader = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
`;

export default function IntroHeader() {
  return (
    <IntroSection>
      <Name>Parmeet Singh</Name>

      <BadgeRow>
        <VerifiedBadge>
          {/* Verified icon */}
          <img src={verifiedIcon} alt="verified badge" />
          <strong>Verified expert</strong> in engineering
        </VerifiedBadge>
      </BadgeRow>

      <MetaList>
        <MetaItem>
          {/* Role icon */}
          <img src={codeIcon} alt="react developer" />
          <span>React developer</span>
        </MetaItem>

        <MetaItem>
          {/* Location icon */}
          <img src={locationIcon} alt="ludhiana, punjab, india" />
          <span>Ludhiana, Punjab, India</span>
        </MetaItem>
      </MetaList>
      <Expertise />
      <BioHeader>Bio</BioHeader>
      <Bio>
        Parmeet is a senior front-end engineer with 7+ years of experience
        building scalable, high-performance web applications. He has architected
        a 70+ web components design system and fixed major performance
        bottlenecks, leading to a 37% faster TTI and 30% lower memory usage. He
        specialises in React, Next.js, TypeScript, and modern UI architecture.
      </Bio>

      <VettedBy placement="mobile" />
    </IntroSection>
  );
}
